import React from 'react';
import {
    CmmLogoShort,
    StyledItemText,
    StyledList,
    StyledListItem,
} from '@/components/Hypertracker/HypertrackerSidebar/HypertrackerSidebarStyled';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router';

const SidebarLogo = ({ open }) => {
    const navigate = useNavigate();

    const handleLogoClick = () => {
        navigate('/hypertracker');
    };

    return (
        <StyledList sx={{ marginBottom: '12px' }}>
            <StyledListItem key={'logo'} disablePadding onClick={handleLogoClick}>
                <ListItemButton
                    sx={{
                        justifyContent: open ? 'initial' : 'center',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                    }}
                >
                    <ListItemIcon
                        sx={{
                            minWidth: 0,
                            justifyContent: 'center',
                        }}
                    >
                        <CmmLogoShort />
                    </ListItemIcon>
                    <StyledItemText
                        primary={
                            <Typography
                                variant={'p20'}
                                fontWeight={600}
                                color={'text.primary'}
                                ml={'8px'}
                            >
                                HyperTracker
                            </Typography>
                        }
                        sx={{
                            opacity: open ? 1 : 0,
                        }}
                    />
                </ListItemButton>
            </StyledListItem>
        </StyledList>
    );
};

export default SidebarLogo;
